import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '@/views/layout/index.vue';
import { getToken } from '@/utils/storage';
import store from '@/store';
Vue.use(VueRouter);

export const asyncRoutes = [
  // {
  //   path: '/bigData',
  //   name: 'BigData',
  //   meta: { title: '大数据' },
  //   component: () => import('@/views/bigData/index')
  // }
];
export const baseRoutes = [
  {
    path: '/home',
    name: 'Home',
    meta: { title: '首页' },
    component: () => import('@/views/home/index')
  },
  {
    path: '/platform-connect',
    name: 'PlatformConnect',
    meta: { title: '平台互联' },
    component: () => import('@/views/platformConnect/index')
  },
  {
    path: '/search/:searchClass/:id',
    name: 'Search',
    meta: { title: 'search' },
    component: () => import('@/views/search/index')
  },
  {
    path: '/news/:id',
    name: 'News',
    meta: { title: 'news' },
    component: () => import('@/views/news/index')
  },
  {
    path: '/schoolnews/:id',
    name: 'Schoolnews',
    meta: { title: 'schoolnews' },
    component: () => import('@/views/schoolnews/index')
  },
  {
    path: '/ing/:id',
    name: 'Ing',
    meta: { title: 'ing' },
    component: () => import('@/views/search/ing')
  },
  {
    path: '/qualityeducation/:id',
    name: 'Qualityeducation',
    meta: { title: 'qualityeducation' },
    component: () => import('@/views/qualityeducation/index')
  },
  {
    path: '/announcement',
    name: 'Announcement',
    meta: { title: 'announcement' },
    component: () => import('@/views/announcement/index')
  },
  {
    path: '/detail/:id',
    name: 'Detail',
    meta: { title: 'detail' },
    component: () => import('@/views/Detail/index')
  },
  {
    path: '/module/:id',
    name: 'Module',
    component: () => import('@/views/module/module')
  },
  {
    path: '/danye/:id',
    name: 'Danye',
    component: () => import('@/views/danye/index')
  },
  {
    path: '/help',
    name: 'Help',
    redirect: { name: 'mainItem' },
    component: () => import('@/views/helpCenter/HelpCenterMain'),
    hidden: false,
    children: [
      {
        path: 'mainItem',
        name: 'mainItem',
        component: () => import('@/views/helpCenter/mainItem')
      },
      {
        path: 'detail',
        name: 'mainDetail',
        component: () => import('@/views/helpCenter/mainDetail')
      }
    ]
  }
];
export const constantRoutes = [
  {
    path: '/ylqHome',
    name: 'YLQHome',
    component: () => import('@/views/ylqHome/index'),
    hidden: true
  },
  {
    path: '/cloudOfficeHome',
    name: 'CloudOfficeHome',
    component: () => import('@/views/ylqHome/cloudOfficeHome'),
    hidden: true
  },
  { path: '*', redirect: '/404', hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    redirect: '/home',
    hidden: false,
    children: baseRoutes
  },
  {
    path: '/searchResult/:id',
    name: 'searchResult',
    component: () => import('@/views/searchResult/index')
  },
  {
    path: '/searchResultDetail/:id',
    name: 'searchResultDetail',
    component: () => import('@/views/searchResult/detail')
  },
  {
    path: '/moduleResult/:id',
    name: 'ModuleResult',
    component: () => import('@/views/module/index')
  },
  {
    path: '/moduleDetail/:id',
    name: 'ModuleDetail',
    component: () => import('@/views/module/detail')
  }
];

const createRouter = () =>
  new VueRouter({
    // mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  });

const router = createRouter();

// 重置路由
export function resetRouter(router) {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // the relevant part
}
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch(err => err);
};
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.repalce = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};
router.beforeEach((to, from, next) => {
  if (getToken() && !store.getters.userInfo.accountId && !to.query.status) {
    store.dispatch('FedLogOut').then(() => {
      location.reload();
      // this.$router.push('/');
    });
  } else {
    next();
  }
});
export default router;
